import { DynamicBlock } from '../../DynamicBlock/DynamicBlock';
import { usePersonalizedContent } from '../utils/usePersonalizedContent';

type PersonalizedContentProps = { id: string; placeholder?: JSX.Element | JSX.Element[] };

export const PersonalizedContent = ({ id, placeholder }: PersonalizedContentProps) => {
	const { content, loaded, error } = usePersonalizedContent(id);

	if (content) {
		return <DynamicBlock {...content} />;
	}

	if (placeholder && !loaded && !error) {
		return <>{placeholder}</>;
	}

	return null;
};
